import { MapTo } from '@adobe/aem-react-editable-components';
import FooterComponent, { FooterComponentEditConfig } from './FooterComponent';

export default MapTo('cob-corp-acquisition/components/creditonebank/footer-component')(FooterComponent, FooterComponentEditConfig);